import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Skeleton } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));

export default function HistorySkeleton() {
    return (
        <Box sx={{ width: "100%", padding: "20px" }}>
            <Grid container xs={12} style={{
                border: "1px solid #E0E0E0",
                textAlign: "center",
                padding: "20px ",
                borderRadius: "6px",
            }}>
                <Grid item xs={3} style={{ marginBottom: '10px' }}>
                    <Skeleton variant="rounded" width={210} height={20} />
                </Grid>
                <Grid item xs={3} style={{ marginBottom: '10px' }}>
                    <Skeleton variant="rounded" width={210} height={20} />
                </Grid>
                <Grid item xs={3} style={{ marginBottom: '10px' }}>
                    <Skeleton variant="rounded" width={210} height={20} />
                </Grid>
                <Grid item xs={3} style={{ marginBottom: '10px' }}>
                    <Skeleton variant="rounded" width={210} height={20} />
                </Grid>
            </Grid>

            <Grid
                container
                xs={12}
                // rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                style={{
                    border: "1px solid #E0E0E0",
                    textAlign: "center",
                    padding: "20px ",
                    borderRadius: "6px",
                }}
            >
                {/* <Grid container xs={12}> */}
                <Grid xl={1.5} lg={2} style={{ marginRight: '20px' }}>
                    <Skeleton variant="rounded" width={100} height={100} />
                    <Skeleton style={{ marginTop: '10px' }} variant="rounded" width={100} height={30} />
                </Grid>
                <Grid xl={9.5} lg={9} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Skeleton variant="rounded" width={210} height={20} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={210} height={20} />
                        </Grid>
                        <Grid item xs={12}>
                            <Skeleton variant="rounded" width={210} height={20} />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Box>
    );
}
